export default __webpack_public_path__ + "static/media/lisieux03.ede3b540.jpg";